import { Link } from 'react-router-dom';
import { useMsal, } from '@azure/msal-react';
import LoadingAnimation from "../../components/loading/loading";
import { useState, useEffect, useMemo } from "react";
import { CompanyAPI } from '../../api/company/company-api-factory';
import { LandlordContainer } from '../../components/company/landlord-container';


import './../properties/property.css';

export const LandlordSearch = () => {

    const { instance, inProgress, accounts } = useMsal();
    const [companyData, setCompanyData] = useState(null);
    const [fetchInProgress, setFetchInProgress] = useState(false);
    const [shouldFetch, setShouldFetch] = useState(true);

    const api = useMemo(() => new CompanyAPI(instance, inProgress, accounts, true), [instance, inProgress, accounts]); // TODO: REVERT - testing localStorage

    useEffect(() => {
        if (shouldFetch && !fetchInProgress) {

            setFetchInProgress(true);

            api.getAll() // Landlords are associated with companies. Most users will only have one company...
                .then(data => {
                    setCompanyData(data);
                })
                .catch(error => {
                    console.log("An error occurred getting data from the Company Data API.", error);
                    setCompanyData(null);
                })
                .finally(() => {
                    setShouldFetch(false);
                    setFetchInProgress(false);
                });
        }
    }, [shouldFetch, fetchInProgress, instance, inProgress, accounts]);

    return (
        <>
            <ol className="breadcrumb float-xl-end">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/landlords/search">Landlord Search</Link></li>
                <li className="breadcrumb-item active">Results</li>
            </ol>
            <h1 className="page-header">Owners & Landlords | <small>manage the owners/landlords associated with <strong>{(companyData && companyData.flatMap(cd => cd.name).join(", ")) ?? "Please wait..."}</strong></small></h1>
            {fetchInProgress && <LoadingAnimation />}
            {!fetchInProgress && companyData && <LandlordContainer companies={companyData} />}
            {!fetchInProgress && !companyData && <>Nothing to show...</>}
        </>
    );
};